import { Router } from './router.js';
import { Header, mountHeader } from './components/Header.js';
import { Footer } from './components/Footer.js';
import { LandingPage } from './pages/LandingPage.js';
import { CatalogPage } from './pages/CatalogPage.js';
import { StudioPage } from './pages/StudioPage.js';
import { StaticPage } from './pages/StaticPage.js';
import { SitemapPage } from './pages/SitemapPage.js';
import { localeManager } from './i18n/index.js';

const routes = [
  { pattern: /^\/$/, keys: [], page: (context) => LandingPage(context) },
  { pattern: /^\/catalog\/?$/, keys: [], page: (context) => CatalogPage(context) },
  { pattern: /^\/catalog\/([^/]+)\/?$/, keys: ['categoryId'], page: (context) => CatalogPage(context) },
  { pattern: /^\/studio\/([^/]+)\/([^/]+)\/?$/, keys: ['categoryId', 'templateId'], page: (context) => StudioPage(context) },
  ...['about', 'contact', 'privacy-policy', 'cookie-policy', 'terms-of-use', 'disclaimer', 'accessibility', 'help', 'feedback'].map((pageId) => ({ pattern: new RegExp(`^/${pageId}/?$`), keys: [], page: () => StaticPage({ pageId }) })),
  { pattern: /^\/sitemap\/?$/, keys: [], page: () => SitemapPage() },
  { pattern: /.*/, keys: [], notFound: true, page: () => ({ title: 'Page not found — KIPS DESIGN', html: '<main id="main-content" class="empty-state section-shell"><span class="empty-icon">404</span><h1>Page not found</h1><p>The requested KIPS DESIGN route does not exist.</p><a class="button button-primary" href="/" data-link>Go home</a></main>' }) }
];

export class App {
  constructor(root) {
    this.root = root;
    this.router = new Router(routes);
    this.cleanupPage = null;
    this.renderToken = 0;
    this.router.addEventListener('route', (event) => this.render(event.detail));
    localeManager.addEventListener('change', () => this.router.resolve());
  }

  start() {
    this.router.resolve();
  }

  async render(route) {
    const token = ++this.renderToken;
    this.cleanupPage?.();
    this.cleanupPage = null;
    const page = route.page({ params: route.params, router: this.router });
    document.title = page.title ?? 'KIPS DESIGN';
    document.querySelector('meta[name="description"]')?.setAttribute('content', page.description ?? 'KIPS DESIGN 2D + 3D visual space designer.');
    document.body.className = page.bodyClass ?? '';
    this.root.innerHTML = `<div id="app-announcer" class="sr-only" aria-live="polite"></div>${Header()}${page.html}${page.hideFooter ? '' : Footer()}`;
    mountHeader(this.root);
    if (!location.hash && !page.bodyClass?.includes('studio-active')) window.scrollTo({ top: 0, behavior: 'instant' });
    if (page.mount) {
      const cleanup = await page.mount(this.root);
      if (token !== this.renderToken) cleanup?.();
      else this.cleanupPage = cleanup;
    }
  }
}
